// Client-side geodesy for the corroboration gate.
//
// The gate hides the "Me too" button from out-of-range users rather than
// showing-then-rejecting, so the distance must be computable in the browser
// from the report's (possibly snapped) coordinate and the device's GPS fix.
// A spherical haversine is plenty accurate at the ~1 km scale the gate cares
// about; PostGIS does the authoritative ST_DWithin server-side.

const R = 6371000; // mean Earth radius, metres
const toRad = (deg) => (deg * Math.PI) / 180;

/**
 * Great-circle distance between two lat/lng points, in metres.
 * Symmetric with the server's ST_DWithin on geography(Point, 4326).
 */
export function distanceM(lat1, lng1, lat2, lng2) {
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2
    + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
